import React from 'react';
import { Helmet, } from 'react-helmet';
import clientConfig from '../config/clientConfig';

const GtmContainer = () => {
  const dataLayer = 'dataLayer = [];';
  const gtmScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${clientConfig.gtmCode}');`;

  return (
    <Helmet>
      <link as="script" rel="preload" href={`https://www.googletagmanager.com/gtm.js?id=${clientConfig.gtmCode}`} />
      <script>{dataLayer}</script>
      <script>{gtmScript}</script>
    </Helmet>
  );
};

export default GtmContainer;
